// constants for pages
export const SET_PAGE_DATA = "SET_PAGE_DATA";
export const SET_PAGE_INFORMATION = "SET_PAGE_INFORMATION";
export const SET_AUCTION_EDITION = "SET_AUCTION_EDITION";
